import React, { useEffect, useState, useRef } from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'

const CardAccess = ({ props, func }) => {
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    setDisabled(props.disebled)
  }, [props])
  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <div>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              marginBottom: '10px',
            }}
          >
            {props.photo && (
              <Avatar
                alt={props.name}
                src={props.photo}
                sx={{ width: 45, height: 45 }}
              />
            )}
            <div>
              <Typography variant="body2" gutterBottom>
                {props.surname} {props.name} {props?.patronymic}
              </Typography>
              <Typography variant="body2" gutterBottom>
                Судейская категория: {props.rank}
              </Typography>
            </div>
          </Stack>
        </div>
        <IconButton
          aria-label="delete"
          disabled={disabled}
          onClick={(e) => func(props)}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>
    </>
  )
}
export default CardAccess
